const { code, empty } = require('./booking-detail')

const definitions = {
  book: {
    name: 'Book',
    icon: 'pi-send',
    description: 'Request a confirmed booking.',
    explanation: 'Request a confirmed booking. Reservations can then record the airline’s response.',
    button: 'Request booking',
    fields: ['comment'],
    required_fields: []
  },
  mark_booked_provisionally: {
    name: 'Held',
    icon: 'pi-clock',
    description: 'Record the airline hold, PNR and deadline.',
    explanation: 'Record the airline’s provisional confirmation, PNR and deadlines.',
    button: 'Save hold',
    fields: ['pnr', 'payment_time_limit', 'ticketing_time_limit', 'comment'],
    required_fields: ['pnr'],
    required_one_of: [['payment_time_limit', 'ticketing_time_limit']]
  },
  mark_booked: {
    name: 'Booked',
    icon: 'pi-check-circle',
    description: 'Record the airline’s final confirmation.',
    explanation: 'Record the airline’s final confirmation and save the PNR.',
    button: 'Save confirmation',
    fields: ['pnr', 'comment'],
    required_fields: ['pnr', 'comment']
  },
  mark_not_available: {
    name: 'Unavailable',
    icon: 'pi-times-circle',
    tone: 'danger',
    description: 'Record that the flight is unavailable and why.',
    explanation: 'Record that the airline cannot fulfil this booking and explain why.',
    button: 'Save outcome',
    fields: ['comment'],
    required_fields: ['comment']
  },
  attach_ticket: {
    name: 'Ticketed',
    icon: 'pi-ticket',
    description: 'Attach the ticket issued by the airline.',
    explanation: 'Attach the ticket issued by the airline and set this booking to Ticketed.',
    button: 'Attach ticket',
    fields: ['ticket', 'comment'],
    required_fields: ['ticket']
  }
}

function bookingManualActions(booking) {
  if (!booking || code(booking.booking_mode) !== 'manual' || !Array.isArray(booking.available_actions)) return []
  return booking.available_actions.filter(action => action && Object.prototype.hasOwnProperty.call(definitions, action.code) && (!(booking.manual_booking || {}).applied_offer_id || ['book', 'attach_ticket'].includes(action.code)))
    .map(action => {
      const definition = definitions[action.code]
      return {
        ...action,
        ...definition,
        required_fields: Array.from(new Set([...definition.required_fields, ...(action.required_fields || [])])),
        required_one_of: action.required_one_of && action.required_one_of.length ? action.required_one_of : definition.required_one_of || []
      }
    }).sort((first, second) => (first.sort || 0) - (second.sort || 0) || first.code.localeCompare(second.code))
}

function deadlineInput(value) {
  if (empty(value)) return ''
  const timestamp = new Date(value).getTime()
  return Number.isFinite(timestamp) ? new Date(timestamp + (3 * 3600000)).toISOString().slice(0, 16).replace('T', ' ') : ''
}

function deadlinePayload(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2} ([01]\d|2[0-3]):[0-5]\d$/.test(value)) return null
  const iso = `${value.replace(' ', 'T')}:00+03:00`
  return deadlineInput(iso) === value ? iso : null
}

function manualActionDraft(booking) {
  return { pnr: booking.pnr || '', payment_time_limit: deadlineInput(booking.payment_time_limit), ticketing_time_limit: deadlineInput(booking.ticketing_time_limit), comment: '', ticket: {} }
}

function manualActionPayload(action, draft) {
  const payload = {}
  for (const field of action.fields) {
    if (field === 'ticket') {
      if (draft.ticket && draft.ticket.id) payload.ticket = draft.ticket.id
    } else if (field.endsWith('_time_limit')) {
      if (!empty(draft[field])) payload[field] = deadlinePayload(draft[field])
    } else if (!empty(draft[field])) payload[field] = String(draft[field]).trim()
  }
  return payload
}

function manualActionErrors(action, draft) {
  const payload = manualActionPayload(action, draft)
  const errors = {}
  for (const field of action.required_fields) {
    if (empty(payload[field])) errors[field] = 'This field is required.'
  }
  if (payload.pnr && payload.pnr.length > 100) errors.pnr = 'PNR must be 100 characters or fewer.'
  for (const field of action.fields.filter(field => field.endsWith('_time_limit'))) {
    if (!empty(draft[field]) && !payload[field]) errors[field] = 'Enter a valid date and time.'
  }
  for (const fields of action.required_one_of) {
    if (!fields.some(field => !empty(payload[field]))) errors.deadlines = 'Enter at least one deadline: payment or ticketing.'
  }
  if (payload.ticket && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(payload.ticket)) errors.ticket = 'Upload a valid ticket file.'
  return errors
}

function manualActionState(booking) {
  const manual = booking.manual_booking || {}
  return JSON.stringify([code(booking.booking_mode), code(booking.status), code(manual.request_status), code(manual.provider_status), booking.pnr || '', booking.payment_time_limit || '', booking.ticketing_time_limit || '', (booking.ticket && booking.ticket.id) || ''])
}

module.exports = { bookingManualActions, deadlineInput, deadlinePayload, manualActionDraft, manualActionPayload, manualActionErrors, manualActionState }
